import { render, staticRenderFns } from "./YoutubeUploader.vue?vue&type=template&id=215faeb2&scoped=true&"
import script from "./YoutubeUploader.vue?vue&type=script&lang=js&"
export * from "./YoutubeUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215faeb2",
  null
  
)

export default component.exports